import "./chunk-4AFQP74Z.js";

// src/modal.tsx
import { Fragment, createElement } from "react";
import { create } from "zustand";
import { Fragment as Fragment2, jsx } from "react/jsx-runtime";
var useQueueStore = create((set, get) => {
  const priorityQueue = (priority) => {
    switch (priority) {
      case "important":
        return get().importantQueue;
      case "standard":
        return get().standardQueue;
      case "onboard":
        return get().onboardQueue;
    }
  };
  const setQueue = (newQueue, priority) => {
    switch (priority) {
      case "important":
        set({ importantQueue: newQueue });
        return null;
      case "standard":
        set({ standardQueue: newQueue });
        return null;
      case "onboard":
        set({ onboardQueue: newQueue });
        return null;
    }
  };
  return {
    importantQueue: /* @__PURE__ */ new Map(),
    standardQueue: /* @__PURE__ */ new Map(),
    onboardQueue: /* @__PURE__ */ new Map(),
    combinedQueue: () => [
      ...get().importantQueue.entries(),
      ...get().standardQueue.entries(),
      ...get().onboardQueue.entries()
    ],
    isModalVisible: () => get().combinedQueue().length > 0,
    add: (presenting, options) => {
      var _a;
      const [queueKey, modal] = (() => {
        var _a2;
        if (typeof presenting === "string") {
          return [presenting, null];
        } else {
          const queueKey2 = (_a2 = options == null ? void 0 : options.key) != null ? _a2 : Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
          return [queueKey2, presenting];
        }
      })();
      const priority = (_a = options == null ? void 0 : options.priority) != null ? _a : "standard";
      const queue = priorityQueue(priority);
      if (options == null ? void 0 : options.key) {
        for (const key of queue.keys()) {
          if (key === queueKey) {
            return;
          }
        }
      }
      setQueue(new Map([[queueKey, modal], ...queue]), priority);
    },
    remove: (key) => {
      const removeFromQueue = (priority) => {
        const queue = priorityQueue(priority);
        let queueKey = typeof key === "string" ? key : void 0;
        if (!queueKey && queue.size > 0) {
          queueKey = queue.keys().next().value;
        }
        if (queueKey && queue.has(queueKey)) {
          queue.delete(queueKey);
          setQueue(new Map(queue), priority);
          return true;
        } else {
          return false;
        }
      };
      const priorities = ["important", "standard", "onboard"];
      for (const priority of priorities) {
        if (removeFromQueue(priority)) {
          break;
        }
      }
    }
  };
});
var useModal = () => {
  return {
    present: useQueueStore((state) => state.add),
    dismiss: useQueueStore((state) => state.remove)
  };
};
var useModalTopKey = () => {
  const entry = useQueueStore((state) => state.combinedQueue()).at(0);
  if (entry) {
    const [key] = entry;
    return key;
  }
};
var useModalVisible = () => {
  return useQueueStore((state) => state.isModalVisible());
};
var ModalProvider = () => {
  const entries = useQueueStore((state) => state.combinedQueue());
  const reverseEntries = [...entries].reverse();
  return /* @__PURE__ */ jsx(Fragment2, { children: reverseEntries.map(([key, modal]) => /* @__PURE__ */ jsx(Fragment, { children: typeof modal === "function" ? createElement(modal) : modal }, key)) });
};
var ModalPresenter = (props) => {
  const topModalKey = useModalTopKey();
  if (topModalKey === props.queueKey) {
    return props.children;
  }
};
export {
  ModalPresenter,
  ModalProvider,
  useModal,
  useModalTopKey,
  useModalVisible
};
